import styled from "styled-components";
import {useState} from "react";
import {toast} from "react-toastify";
import {schemas} from "../../config";
import {act343PrizeMap, inmsg343PortalFilters, inmsg343Ps5Filters, inmsg343SilpoFilters} from "../InmsgTable";
import {FieldMapValue} from "../../Types";
import {LANG} from "../../components/CONSTANTS";
import {useAppDispatch} from "../../hooks";
import {fetchTableByQuery, setTableFilters} from "../../features/tableSlice";


export default function SendCertificates() {

    const [ids, setIds] = useState("")
    const [sending, setSending] = useState(false);

    const schema = schemas['act343']

    function send() {
        setSending(true)
        toast.info("Відправляємо емейли. Може зайняти певний час...")
        fetch(
            `${schema.backend}/343/sendCertificates.php`,
            {
                credentials: 'include',
                method: "POST",
                body: JSON.stringify({ids: ids})
            })
            // .then(handleFetchResponseStatus)
            .then(r => r.json())
            .then(r => {
                if (r.have_error)
                    toast.error("Деякі емейли не були відправлені")
                if (r.error === true) {
                    toast.error(r.errorBody || "Сталась помилка при розсилці")
                } else {
                    toast.info("Емейли були відправлені переможцям. Оновіть таблицю")
                }
                setSending(false)
            })
    }

    return <Container>
        <div>ВІДПРАВИТИ СЕРТИФІКАТИ ПЕРЕМОЖЦЯМ</div>
        <label htmlFor="ids">Список ID РЕЄСТРАЦІЙ ПЕРЕМОЖЦІВ через кому</label>
        <input type="text" id={"ids"} value={ids} placeholder={"2,45,78,123,54"}
               onChange={(e) => setIds(e.target.value)}/>
        <button className="btn-cmn" onClick={send} disabled={sending}>
            Підтвердити
        </button>

    </Container>
}

const Container = styled.div`
    display: flex;
    width: 100%;
    background: var(--table-row-odd-bg-color);
    color: var(--table-row-text-color);
    padding: .5rem;
    border-radius: .5rem;
    justify-content: center;
    align-items: center;
    gap: .5rem;
    flex-flow: column;

    & input, select, button {
        width: 100%;
        max-width: 600px;

    }

    & .email {
        word-break: normal;
        line-height: 1.4;
    }
`
